import type { Observable } from 'rxjs';
import type { HttpDataResponse } from '@common/types/http-response.type';
import type { EduCoursePayment } from '@common/types/payment-form.type';

import { Injectable } from '@angular/core';
import { shareReplay } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseHttpService } from '@common/services/REST/base.http.service';

@Injectable({
    providedIn: 'root',
})
export class EduCoursePaymentsHttpService extends BaseHttpService {
    public getEduCoursePayments(courseId: number): Observable<EduCoursePayment[]> {
        return this.http
            .get<HttpDataResponse<EduCoursePayment[]>>(this.formatApiUrl(`education/courses/${courseId}/payments`))
            .pipe(
                shareReplay(),
                map((data: any) => data.data)
            );
    }
}
